import { ADMIN_LIST_PAGE_SIZE_OPTIONS, type AdminListPageSize } from "./useAdminListState";

type AdminPaginationProps = {
  page: number;
  pageSize: AdminListPageSize;
  totalCount: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: AdminListPageSize) => void;
};

export function AdminPagination({
  page,
  pageSize,
  totalCount,
  onPageChange,
  onPageSizeChange
}: AdminPaginationProps) {
  const pageCount = Math.max(1, Math.ceil(totalCount / pageSize));
  const currentPage = Math.min(Math.max(1, page), pageCount);
  const start = totalCount === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const end = Math.min(totalCount, currentPage * pageSize);

  return (
    <nav className="admin-pagination" aria-label="一覧ページ送り">
      <p>全{totalCount}件中 {start}〜{end}件</p>
      <div className="admin-pagination__controls">
        <button type="button" disabled={currentPage <= 1} onClick={() => onPageChange(1)}>«</button>
        <button type="button" disabled={currentPage <= 1} onClick={() => onPageChange(currentPage - 1)}>前へ</button>
        <span>{currentPage} / {pageCount}</span>
        <button type="button" disabled={currentPage >= pageCount} onClick={() => onPageChange(currentPage + 1)}>次へ</button>
        <button type="button" disabled={currentPage >= pageCount} onClick={() => onPageChange(pageCount)}>»</button>
        <label>
          <span>表示件数</span>
          <select
            value={pageSize}
            onChange={(event) => onPageSizeChange(Number.parseInt(event.target.value, 10) as AdminListPageSize)}
          >
            {ADMIN_LIST_PAGE_SIZE_OPTIONS.map((option) => (
              <option key={option} value={option}>{option}</option>
            ))}
          </select>
        </label>
      </div>
    </nav>
  );
}
